import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
const PIXEL_ID = '2504610289971927';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const n = window.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;
      (n as any).callMethod.apply(n, args);
    } else {
      ;
      (n as any).queue.push(args);
    }
  } as any;
  if (!window._fbq) window._fbq = n;
  (n as any).push = n;
  (n as any).loaded = true;
  (n as any).version = '2.0';
  (n as any).queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return <SalesPage data-id="element-0" />;
}